import PropTypes from "prop-types";
import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";
import Link from "../../../../elements/Link";

var Table = function Table(_ref) {
  var data = _ref.data,
      headerScope = _ref.headerScope;
  var getClassName = getClassNameFactory(Table.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, /*#__PURE__*/React.createElement("table", null, data.caption && data.caption.content && /*#__PURE__*/React.createElement("caption", null, data.caption.content), data.head && data.head.rows && data.head.rows.length && /*#__PURE__*/React.createElement("thead", null, data.head.rows.map(function (row, indexRow) {
    return /*#__PURE__*/React.createElement("tr", {
      key: (typeof row.key === "undefined" ? indexRow : row.key).toString()
    }, row.cells && row.cells.map(function (cell, indexCell) {
      var style = {};
      var base = 16;

      if (cell.width) {
        style.minWidth = "".concat(cell.width / base, "rem");
      }

      return /*#__PURE__*/React.createElement("th", {
        key: (typeof cell.key === "undefined" ? indexCell : cell.key).toString(),
        scope: headerScope
      }, /*#__PURE__*/React.createElement("div", {
        className: getClassName({
          descendantName: "columnWidthPlaceholder"
        }),
        style: style
      }), cell.content);
    }));
  })), data.bodies && data.bodies.length && data.bodies.map(function (body, indexBody) {
    return /*#__PURE__*/React.createElement("tbody", {
      key: (typeof body.key === "undefined" ? indexBody : body.key).toString()
    }, body.rows && body.rows.length && body.rows.map(function (row, indexRow) {
      return row.hidden !== true && /*#__PURE__*/React.createElement("tr", {
        key: (typeof row.key === "undefined" ? indexRow : row.key).toString()
      }, row.cells && row.cells.map(function (cell, indexCell) {
        return /*#__PURE__*/React.createElement("td", {
          key: (typeof cell.key === "undefined" ? indexCell : cell.key).toString()
        }, cell.link && cell.link.href ? /*#__PURE__*/React.createElement(Link, {
          href: cell.link.href
        }, cell.content) : cell.content);
      }));
    }));
  })));
};

Table.displayName = "TableWithFilters.Table";
Table.propTypes = {
  /**
   * Initialize <input> with a value
   */
  data: PropTypes.object,
  headerScope: PropTypes.string
};
export default Table;